import { styled, Typography } from '@mui/material'
import { ExclamationMarkIcon } from '@weblite/icons'
import { CallType } from '@weblite/ts-action/media-proxy'
import { closeCurrentModal } from 'weblite-web-modal-viewer'
import { BottomDrawer } from '$common/bottom-drawer'
import { t } from '$i18n'
import { PrimaryButton } from '$common/buttons'

export interface Props {
  isOpen?: boolean
  callType: CallType
}

export function CallRoomIsFull({ isOpen = false, callType }: Props) {
  return (
    <BottomDrawer isOpen={isOpen} onClose={closeCurrentModal}>
      <Root>
        <IconContainer sx={{ mb: '32px' }}>
          <ExclamationMarkIcon
            sx={{ width: 48, height: 48, color: 'inherit' }}
          />
        </IconContainer>
        <Typography textAlign="center" variant="h2" sx={{ mb: '16px' }}>
          {t('callRoomIsFullDialog.title')(t(`call.${callType}`))}
        </Typography>
        <Typography textAlign="center" variant="paragraph1" sx={{ mb: '16px' }}>
          {t('callRoomIsFullDialog.description')(t(`call.${callType}`))}
        </Typography>
        <PrimaryButton
          fullWidth
          variant="contained"
          color="primary"
          onClick={closeCurrentModal}
          text={t('callRoomIsFullDialog.submitText')}
        />
      </Root>
    </BottomDrawer>
  )
}

const Root = styled('div')`
  display: flex;
  flex-direction: column;
  align-items: center;
  box-sizing: border-box;
  padding: 24px 16px;
`

const IconContainer = styled('div')`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100px;
  height: 100px;
  border-radius: 50%;
  background-color: ${({ theme }) => theme.palette.error100};
  color: ${({ theme }) => theme.palette.error500};
`
